export enum ActionTypes {
  SET_CUSTOM_DATA = 'CONFIGURATOR/SET_CUSTOM_DATA',
}
